module.exports = __webpack_public_path__ + "img/1440.8c4a3668.jpg";